import React, { useEffect } from 'react';
import { X } from "lucide-react";

// Help Modal Component
const HelpModal = ({ isOpen, onClose, isDark }) => {
    useEffect(() => {
      const handleEscape = (event) => {
        if (event.key === 'Escape') {
          onClose();
        }
      };

      if (isOpen) {
        document.addEventListener('keydown', handleEscape);
      }

      return () => {
        document.removeEventListener('keydown', handleEscape);
      };
    }, [isOpen, onClose]);

    if (!isOpen) return null;
    
    return (
      <div
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
        onClick={onClose}
      >
        <div
          className={`w-full max-w-2xl overflow-hidden flex flex-col rounded-lg
          ${isDark ? 'bg-gray-800' : 'bg-white'}`}
          onClick={e => e.stopPropagation()}
        >
          <div className={`p-4 border-b flex justify-between items-center
            ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
            <h2 className={`text-lg font-semibold
              ${isDark ? 'text-white' : 'text-gray-900'}`}>
              How to use the Search
            </h2>
            <button 
              onClick={onClose}
              className={`${isDark ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'}`}
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <div className={`p-6 overflow-auto ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
            <div className="space-y-4">
              <p><strong>Quick Start:</strong></p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Start typing in the search box to find contacts</li>
                <li>At least 3 characters are required to start the search</li>
                <li>The search is performed on the following fields: First Name, Last Name, Email, Phone Number</li>
                <li>Results will update automatically as you type</li>
              </ul>
              
              <p><strong>Customizing Results:</strong></p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Click the "Customize Columns" button to choose which properties to display</li>
                <li>Select or deselect properties to modify the table columns</li>
                <li>Your column preferences will be preserved</li>
              </ul>
  
              <p><strong>Tips:</strong></p>
              <ul className="list-disc pl-5 space-y-2">
                <li>The interface automatically adapts to your system's light/dark mode</li>
                <li>Table can be scrolled horizontally if needed</li>
                <li>Wait a moment between typing to avoid hitting rate limits</li>
              </ul>
            </div>
          </div>
          <div className={`p-4 border-t ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
            <button
              onClick={onClose}
              className={`w-full px-4 py-2 rounded-lg
                ${isDark 
                  ? 'bg-gray-700 hover:bg-gray-600 text-gray-200' 
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-800'}`}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  export default HelpModal;